import axios from "axios";
import Errores from "@/utils/Errores";

export const ProcesaJsonParametros = {
  obtenerInformacion: async (componente, tokenBearer) => {
    try {
      const response = await axios.get(JSONPARAMETROS, {
        headers: {
          Authorization: `Bearer ${tokenBearer}`
        }
      });

      if (response.data) {
        const parametros = response.data.reduce((acc, elemento) => {
          acc[elemento.llave] = elemento;
          return acc;
        }, {});

        if (parametros.anioPostulacion) {
          return {
            parametroAnioPostulacion: parametros.anioPostulacion,
            parametroAnioAdmision: parametros.anioAdmision,
            parametroInicioPostulacion: parametros.inicioPostulacion,
            parametroFinPostulacion: parametros.finPostulacion,
            parametroFechaPeriodoComplementario:
              parametros.fechaPeriodoComplementario,
            parametroFechaListaEspera: parametros.fechaListaEspera,
            parametroFechaResultadosFinales: parametros.fechaResultadosFinales,
            parametroAnioSiguiente: parametros.anioSiguiente,
            parametroAnioAnterior: parametros.anioAnterior,
            parametroAnioIndicadorCatDesempenioBasica:
              parametros.anioIndicadorCatDesempenioBasica,
            parametroAnioIndicadorCatDesempenioMedia:
              parametros.anioIndicadorCatDesempenioMedia,
            parametroAnioIndicadorCatSimceBasica:
              parametros.anioIndicadorCatSimceBasica,
            parametroAnioIndicadorCatSimceMedia:
              parametros.anioIndicadorCatSimceMedia,
            parametroAnioIndicadorCatDesarrolloBasica:
              parametros.anioIndicadorCatDesarrolloBasica,
            parametroAnioIndicadorCatDesarrolloMedia:
              parametros.anioIndicadorCatDesarrolloMedia
          };
        } else {
          console.error("Respuesta de JSON incorrecta");
          return null;
        }
      }
    } catch (error) {
      Errores.switchErrors(error, componente);
      console.error(
        "Error al cargar parámetros iniciales desde JSON:",
        error.response || error.message || error
      );
      return null;
    }
  }
};

export default ProcesaJsonParametros;



// WEBPACK FOOTER //
// ./src/services/ProcesaJsonParametros.js